<div class="change-container">
  <div class="form-container">
    <div class="form-header">Change Account Details Request Form</div>
    <form [formGroup]="modalForm">
      <div class="form-group">
        <div class="form-field">
          <textarea id="request" type="text" cols="100" rows="30" formControlName="request"> </textarea>
          <div class="error" *ngIf="request?.invalid && (request?.dirty || request?.touched)">
            <div *ngIf="request?.errors?.['required']">
              Change request is required.
            </div>
            <div *ngIf="request?.errors?.['maxlength']">
              Change request exceeds the max length of {{MAX_FORM_LENGTH}}.
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="form-actions">
      <button type="button" (click)="onCancel()">Cancel</button>
      <button (click)="submitRequest()" type="submit" [disabled]="!modalForm.valid">Submit</button>
      <button (click)="onSave()" class="save-button" type="button" [disabled]="!modalForm.valid">Save</button>
    </div>
  </div>
</div>
